




































































import { BolsaMultiConfigAjusteProdParmDTO } from '@/interfaces/splitted-bag-config';
import { listSplittedBagConfigsWeekdays, saveSplittedBagConfigs } from '@/services/splitted-bag-config';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import BaseComponent from '../base-component.vue';
import UiAutoCompleteAddress from '../UI/autocomplete-address.vue';

@Component({
  components: {
    UiAutoCompleteAddress
  }
})
export default class SplittedBagAddProdLocationDialog extends BaseComponent {
  @Prop()
  editItem: any;

  dto: any = {
    diasSemanaEntrega: []
  };

  modalOpen = false;
  weekdays = [];

  public form: any = {
    valid: false,
    rules: {
      endereco: [(v) => !!v || 'Selecione um Município ou Estado'],
      dias: [(v) => !!v || 'Informe a quantidade de dias para ajuste']
    }
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  beforeMount() {
    this.loadWeekdays();
  }

  mounted() {
    this.modalOpen = true;
  }

  loadWeekdays() {
    listSplittedBagConfigsWeekdays().subscribe((res) => {
      this.weekdays = res;
    });
  }

  @Watch('editItem', { immediate: true })
  onEditItemChange(editItem) {
    if (editItem == null) {
      return;
    }
    this.dto.endereco = { estado: this.editItem.uf, municipio: this.editItem.municipio };
    this.dto.diasAjuste = editItem.diasAjusteProducao;
    this.dto.diasSemanaEntrega = editItem.diasSemanaEntrega.map((d) => d.id);
  }

  getEnderecoValue() {
    return this.editItem.municipio ? `${this.editItem.municipio} - ${this.editItem.uf}` : this.editItem.uf;
  }

  public close(): void {
    this.$emit('close');
  }

  public save(): void {
    let parm = new BolsaMultiConfigAjusteProdParmDTO();
    parm.uf = this.dto.endereco.estado;
    parm.municipio = this.dto.endereco.municipio;
    parm.diasAjusteProducao = this.dto.diasAjuste;
    parm.diasSemanaEntrega = this.dto.diasSemanaEntrega;
    this.loader.start('Processando...');

    saveSplittedBagConfigs(parm).subscribe(
      (res) => {
        this.toast.show(res, 'success');
        this.loader.stop();
        this.$emit('save');
      },
      (error) => {
        this.loader.stop();
        this.showToastApiError(error);
      }
    );
  }
}
